import { writable } from "svelte/store"
import { querystring } from "svelte-spa-router"
import { queryStringToJSON } from "../../../../Script/queryString"

// Global variable to store parsed query parameters
let query

// Subscribe to changes in the querystring and update the `query` variable accordingly
querystring.subscribe((state) => (query = queryStringToJSON(state)))

/**
 * Represents a document object.
 * @class
 */
export class badgeState {
  /**
   * Constructs a new badgeState instance.
   * @constructor
   */
  constructor() {
    this.documentTemplateId = undefined
    this.proposedURL = undefined
    this.documentId = undefined
    this.Json = {}
    this.uri = undefined
    this.url = ""
    this.dataHash = undefined
    this.txid = undefined
    this.signature = undefined
    this.fileHash = undefined
    this.domain = ""
    this.badgeId = ""
    this.reference = ""
  }
}

/**
 * Represents an array of badgeState instances.
 * @typedef {Array<badgeState>} badgePubArr
 */
/**
 * Retrieves the badge publish data from localStorage.
 * @type {badgePubArr} - The array of badge publish data objects retrieved from local storage.
 */
let stats = localStorage.getItem("P2BBadgePublish")
let data = {}
if (stats == null) {
  try {
    // Parsing the value as JSON
    stats = JSON.parse(stats)
    if (!stats) {
      stats = []
      // Throwing an error if the parsed value is null
      throw new Error("Document value is null")
    }
  } catch (error) {
    // console.error(error)
    // Initializing stats with a new instance of the badgeState class
    // stats = [...stats, new badgeState()]
    // console.log(stats, "stats")
  }
} else {
  stats = JSON.parse(stats)
  for (let i = 0; i < stats.length; i++) {
    if (stats[i].badgeId == query.badgeId) {
      data = stats[i]
    }
  }
}

/**
 * @typedef {Array<BadgePublish>} badgePubArr - badge publisg stats Array.
 * @type {Array}
 * badge publisg stats array.
 */

/**
 * @typedef {Object} BadgePublish - badge publishing stats.
 * @type {Object}
 * badge publishing stats.
 * 
 * @property {String} documentId - denotes the document id from initial api.
 * @property {String} proposedURL - blockChain URL
 * @property {String} documentTemplateId - denotes the selected document template id.
 * @property {Object} metadata - It contains the metadata object.
 * @property {Object} options - It contains the options object.
 * @property {String} uri - The PDF URI (Uniform Resource Identifier) of the document.
 * @property {String} dataHash - dataHash.
 * @property {String} fileHash - fileHash.
 * @property {String} domain - fileHash.
 * @property {String} badgeId - fileHash.
 * @property {String} reference - badge reference.
 * /
 
/**
 * @type {import("svelte/store").Writable<BadgePublish>}
 */

const BadgePublish = writable(data)

/**
 * Updates the value of "P2BBadgePublish" in the localStorage.
 * @param {object} stats - The stats object to be stored.
 */
export const updateBadgePublish = async (stat) => {
  try {
    for (let i = 0; i < stats.length; i++) {
      if (stats[i].badgeId == stat.badgeId) {
        stats[i] = stat
        throw "new entry added"
      }
    }
    stats = [...stats, stat]
  } catch {
    // console.log("new entry")
  } finally {
    localStorage.setItem("P2BBadgePublish", JSON.stringify(stats))
  }
}

/**
 * Updates the value of "P2BBadgePublish" in the localStorage.
 * @param {object} stats - The stats object to be stored.
 */
export const removeDataBadgePublish = async (id) => {
  try {
    stats = stats.filter((stat) => stat.badgeId != id)
  } catch {
    console.error(error)
  } finally {
    localStorage.setItem("P2BBadgePublish", JSON.stringify(stats))
  }
}
export default BadgePublish
